// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import _ from "lodash";
import React, { RefObject } from "react";
import { connect } from "react-redux";
import { Label } from "office-ui-fabric-react/lib/Label";
import { IconButton } from "office-ui-fabric-react/lib/Button";
import size from "lodash/size";
import { RouteComponentProps } from "react-router-dom";
import SplitPane from "react-split-pane";
import axios from "axios";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { bindActionCreators } from "redux";
import Select from "react-select";
//import pdfjsLib from "pdfjs-dist";
import * as pdfjsLib from "pdfjs-dist/legacy/build/pdf";
import HtmlFileReader from "../../../../common/htmlFileReader";
import { SkipButton } from "../../shell/skipButton";
import { strings } from "../../../../common/strings";
import {
    AssetState, AssetType, EditorMode, IApplicationState,
    IAppSettings, IAsset, IAssetMetadata, IProject, IRegion,
    ISize, ITag, IAuthenticationState,
    ILabel,IUserEndPoint
} from "../../../../models/applicationState";
import IApplicationActions, * as applicationActions from "../../../../redux/actions/applicationActions";
import IProjectActions, * as projectActions from "../../../../redux/actions/projectActions";
import IAppTitleActions, * as appTitleActions from "../../../../redux/actions/appTitleActions";
import "./editorPage.scss";
import EditorSideBar from "./editorSideBar";
import Confirm from "../../common/confirm/confirm";
import { constants } from "../../../../common/constants";
import { Spinner, SpinnerSize } from "office-ui-fabric-react/lib/Spinner";
import { getPrimaryRedTheme } from "../../../../common/themes";
// import { SkipButton } from "../../shell/skipButton";
import ModalHeader from "../header/subHeader";
import { ImageMap } from "../../common/imageMap/imageMap";
import Style from "ol/style/Style";
import Stroke from "ol/style/Stroke";
import Fill from "ol/style/Fill";
import JsonResponse from "./jsonResponse";
import { parseTiffData, renderTiffToCanvas, loadImageToCanvas } from "../../../../common/utils";
import { appInfo } from "../../../../common/appInfo";
import HeaderComponent from "../header/header";
import { documentPredictionEndPoint, deleteBlobEndPoint,
    accessTokenData, accessToken, refreshTokenEndPoint, refreshTokenCall } from '../../../../common/api-config'
import ServiceHelper from "../../../../services/serviceHelper";
import OperationsHeader from "../header/operationsSubHeader";

import ProjectService from "../../../../services/projectService";
import AnalysisService from "../../../../services/analysisService";
//import  AssetService  from "../../../../services/assetService";
import LoadingOverlay from "react-loading-overlay";

import BeforeUnloadComponent from "react-beforeunload-component";
const cMapUrl = constants.pdfjsCMapUrl(pdfjsLib.version);


/**
 * Properties for Editor Page
 * @member project - Project being edited
 * @member recentProjects - Array of projects recently viewed/edited
 * @member actions - Project actions
 * @member applicationActions - Application setting actions
 */
export interface ITestQueuesProps extends RouteComponentProps, React.Props<TestQueues> {
    project: IProject;
    recentProjects: IProject[];
    loadAllOPTestFiles: IAsset[];
    appSettings: IAppSettings;
    loggedInUser: IAuthenticationState;
    actions: IProjectActions;
    applicationActions: IApplicationActions;
    appTitleActions: IAppTitleActions;
    uploadFilesCount: number;
}

/**
 * State for Editor Page
 */
export interface ITestQueuesState {
    /** Array of assets in project */
    assets: IAsset[];
    /** The editor mode to set for canvas tools */
    editorMode: EditorMode;
    /** The selected asset for the primary editing experience */
    selectedAsset?: IAssetMetadata;
    /** Currently selected region on current asset */
    selectedRegions?: IRegion[];
    /** Most recently selected tag */

    /** Tags locked for region labeling */
    lockedTags: string[];

    /** Size of the asset thumbnails to display in the side bar */
    thumbnailSize: ISize;
    /**
     * Whether or not the editor is in a valid state
     * State is invalid when a region has not been tagged
     */
    isValid: boolean;
    /** Whether the show invalid region warning alert should display */
    showInvalidRegionWarning: boolean;
    /** Show tags when loaded */
    tagsLoaded: boolean;
    /** The currently hovered TagInputItemLabel */
    hoveredLabel: ILabel;
    /** Whether the task for loading all OCRs is running */
    /** Whether OCR is running in the main canvas */
    isCanvasRunningOCR?: boolean;
    isError?: boolean;
    errorTitle?: string;
    errorMessage?: string;
    /** Test Image States */
    selectedTag: string;
    imageUri: string;
    imageWidth: number;
    imageHeight: number;
    numPages: number;
    currentPage: number;
    outPutFormat: string;
    pdfFile: any;
    tiffImages: any[];
    analyzeResult: any;
    analyseDataLoad: boolean;
    userId: string;
    loadingFiles: boolean;
    uploadFilesCount: number;
    loadResultFormates: any[];
    selectedFormat: any;
    addEndPoint: boolean;
    createValidation: boolean;
    validationCheck: any;
    endpoint: string;
    userTransformations: IUserEndPoint[];
    loadEndPoints: boolean;
    filesCount:number;
}

function mapStateToProps(state: IApplicationState) {
    return {
        recentProjects: state.recentProjects,
        project: state.currentProject,       
        loadAllOPTestFiles: state.loadOPTestFiles,
        loggedInUser: state.loggedInUser,
        appSettings: state.appSettings,
        uploadFilesCount: state.uploadFilesCount,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(projectActions, dispatch),
        applicationActions: bindActionCreators(applicationActions, dispatch),
        appTitleActions: bindActionCreators(appTitleActions, dispatch),
    };
}

/**
 * @name - Editor Page
 * @description - Page for adding/editing/removing tags to assets
 */
@connect(mapStateToProps, mapDispatchToProps)
export default class TestQueues extends React.Component<ITestQueuesProps, ITestQueuesState> {
    public state: ITestQueuesState = {
        selectedTag: null,
        lockedTags: [],
        analyzeResult: null,
        analyseDataLoad: false,
        assets: null,
        imageUri: null,
        imageWidth: 0,
        outPutFormat: "",
        imageHeight: 0,
        pdfFile: null,
        numPages: 1,
        currentPage: 1,
        tiffImages: [],
        errorMessage: null,
        editorMode: EditorMode.Select,
        thumbnailSize: { width: 175, height: 155 },
        isValid: true,
        showInvalidRegionWarning: false,
        tagsLoaded: false,
        hoveredLabel: null,
        userId: null,
        loadingFiles: false,
        uploadFilesCount: null,
        loadResultFormates: [{ value: 'json', label: 'JSON' },{ value: 'xml', label: 'XML' }],
        selectedFormat: null,
        addEndPoint: false,
        createValidation: false,
        validationCheck: true,
        endpoint: null,
        userTransformations: [],
        loadEndPoints: false,
        filesCount:0,
    };


    /** shoe test Image */
    private currPdf: any;
    private tiffImages: any[];
    private imageMap: ImageMap;
    private timeInterval: any;
    private controller = new AbortController();
    private cancelToken;
    private loadingProjectAssets: boolean = false;
    private deleteFileConfirm: React.RefObject<Confirm> = React.createRef();
    private renameCanceled: () => void;
    private isUnmount: boolean = false;

    constructor(props) {
        super(props);
    }

    
    public async componentDidMount() {
       
        window.addEventListener("focus", this.onFocused);
        const user = this.props.loggedInUser;
        const userId = user.user.oid;
        this.setState({ userId });
        this.isUnmount = false;
        const projectId = this.props.match.params["projectId"];
        const projectName = this.props.match.params["projectName"];
        /*
        if (this.props.project) {
            // this.getFilesFromBlob();
           
        } else if (projectId) {
            const recentProject = this.props.recentProjects.find((project) => project.id === projectId);
            const projectCopy = Object.assign({}, recentProject);
            projectCopy.folderPath = `${projectName}-${userId}/testing`;
            await this.props.actions.saveProject(projectCopy, false, false);
            await this.props.actions.loadProject(projectCopy);
        }*/
        this.loadProjectAssets();
        this.getFilesFromBlob();
    }

    public getFilesFromBlob = () => {
        const projectCopy = Object.assign({}, this.props.project);
      //  projectCopy.folderPath = `${this.props.match.params["projectName"]}-${this.state.userId}/testing`;
        this.props.actions.loadBlobs(projectCopy, "OPtesting");

    }

    public async componentDidMount_OLD() {
        window.addEventListener("focus", this.onFocused);
        const user = this.props.loggedInUser;
        const userId = user.user.oid;
        this.setState({ userId });
        this.isUnmount = false;
      //  debugger;
        const projectId = this.props.match.params["projectId"];
        const projectName = this.props.match.params["projectName"];
        const filescount =  this.props.match.params["filesCount"];
        this.setState({ filesCount:filescount });
        //debugger;
      //  this.loadProjectAssets();
      // await this.loadProjectAllAssets();  //this.loadProjectAllAssets();
        /*
        if (this.props.project) {
            // this.getFilesFromBlob();
            this.loadProjectAssets();
        } else if (projectId) {
            const recentProject = this.props.recentProjects.find((project) => project.id === projectId);
            const projectCopy = Object.assign({}, recentProject);
            projectCopy.folderPath = `${projectName}-${userId}/testing`;
            await this.props.actions.saveProject(projectCopy, false, false);
            await this.props.actions.loadProject(projectCopy);
        }*/

        await this.getFilesFromBlob();

        this.loadProjectAssets();
       
    }

  
    /*
    public getFilesFromBlob = () => {
        const projectCopy = Object.assign({}, this.props.project);
        projectCopy.folderPath = `${this.props.match.params["projectName"]}-${this.state.userId}/testing`;
        this.props.actions.loadOpBlobs(projectCopy);

    }*/

    public async componentDidUpdate(prevProps: Readonly<ITestQueuesProps>, prevState) {
        const { project } = this.props;

        if (this.state.assets && this.state.assets.length === 0) {
            await this.loadProjectAssets();
        }       
        if (prevProps.uploadFilesCount && prevProps.uploadFilesCount !== prevState.uploadFilesCount) {
            prevState.uploadFilesCount = prevProps.uploadFilesCount;
            this.getFilesFromBlob();
        }
        if (prevProps.loadAllOPTestFiles.length > 0 && prevProps.loadAllOPTestFiles.length !== (prevState.assets && prevState.assets.length)) {
            localStorage.setItem("OPtestFilesLengthFromTest", prevProps.loadAllOPTestFiles.length.toString())
            prevState.loadingFiles = true;
            await this.loadProjectAssets();
            prevState.loadingFiles = false;
        }
    }

    public async componentDidUpdate_OLD(prevProps: Readonly<ITestQueuesProps>, prevState) {
   
      /*
        if (this.state.assets && this.state.assets.length === 0 ) {
            await this.getFilesFromBlob();
            this.loadProjectAssets();
        }   
*/
        if (prevProps.uploadFilesCount && prevProps.uploadFilesCount !== prevState.uploadFilesCount) {
            prevState.uploadFilesCount = prevProps.uploadFilesCount;
            this.getFilesFromBlob();
            this.loadProjectAssets();
        }

        /*
        const { project } = this.props;

        if (project && this.state.assets && this.state.assets.length === 0) {
            await this.loadProjectAssets();
        }       
       
        if (prevProps.loadAllTestFiles.length > 0 && prevProps.loadAllTestFiles.length !== (prevState.assets && prevState.assets.length)) {
            localStorage.setItem("testFilesLengthFromTest", prevProps.loadAllTestFiles.length.toString())
            prevState.loadingFiles = true;
            await this.loadProjectAssets();
            prevState.loadingFiles = false;
        }
        */
    }

    public componentWillUnmount() {
        this.isUnmount = true;      
        window.removeEventListener("focus", this.onFocused);
        this.analyseData();
    }

    public getFilesFromBlob_OLD = async () => {
        const projectCopy = Object.assign({}, this.props.project);        
       let assetsnData : IAsset [] ;     
       let assetsData;
       assetsData =await this.props.actions.loadOpBlobs(projectCopy)
      .then(function(response){ 
        return response.map((file)=>
        {
            return file;
        });
     }); 
        this.setState({ assets: assetsData});
    }
      
/*
    public loadProjectAllAssets = async () =>   
    {
        const projectService = new ProjectService();
        const loadFiles = await projectService.loadAllFilesFromOpBlob("test");
        const assetService = new AssetService(this.props.project);
        const assetsData = [];

        loadFiles.forEach(async (element: any) => {
            //const stateAsset = await appState.loadAllFiles.find((file) => file.name === element.name);
           // if (!stateAsset) {
            const assets = await assetService.getAssetsFromList(element);
            assetsData.push(assets);
          // dispatch(loadAllBlobFiles(assets));
        //} else {
         //   assetsData.push(stateAsset);
             }  );   //
    }
*/
    /** show Test Image based on left side selection */


    public loadTiffFile = async (asset: IAsset) => {
        const assetArrayBuffer = await HtmlFileReader.getAssetArray(asset);
        const tiffImages = parseTiffData(assetArrayBuffer);
        this.loadTiffPage(tiffImages, this.state.currentPage);
    }

    public loadTiffPage = (tiffImages: any[], pageNumber: number) => {
        const tiffImage = tiffImages[pageNumber - 1];
        const canvas = renderTiffToCanvas(tiffImage);
        this.setState({
            imageUri: canvas.toDataURL(constants.convertedImageFormat, constants.convertedImageQuality),
            imageWidth: tiffImage.width,
            imageHeight: tiffImage.height,
            numPages: tiffImages.length,
            currentPage: pageNumber,
            tiffImages,
        });
    }

    public loadImage = async () => {
        const asset = this.state.selectedAsset.asset;
        if (asset.type === AssetType.Image) {
            const canvas = await loadImageToCanvas(asset.path);
            this.setState({
                imageUri: canvas.toDataURL(constants.convertedImageFormat, constants.convertedImageQuality),
                imageWidth: canvas.width,
                imageHeight: canvas.height,
            });
        } else if (asset.type === AssetType.TIFF) {
            await this.loadTiffFile(asset);
        } else if (asset.type === AssetType.PDF) {
            await this.loadPdfFile(asset.id, asset.path);
        }
    }

    public loadPdfFile = async (assetId, url) => {
        try {
            const pdf = await pdfjsLib.getDocument({ url, cMapUrl, cMapPacked: true }).promise;
            // Fetch current page
            if (assetId === this.state.selectedAsset.asset.id) {
                await this.loadPdfPage(assetId, pdf, this.state.currentPage);
            }
        } catch (reason) {
            // PDF loading error
            console.error(reason);
        }   
    }

    public loadPdfPage = async (assetId, pdf, pageNumber) => {
        const page = await pdf.getPage(pageNumber);
        const defaultScale = 2;
        const viewport = page.getViewport({ scale: defaultScale });

        // Prepare canvas using PDF page dimensions
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        // Render PDF page into canvas context
        const renderContext = {
            canvasContext: context,
            viewport,
        };
        await page.render(renderContext).promise;
        if (assetId === this.state.selectedAsset.asset.id) {
            this.setState({
                imageUri: canvas.toDataURL(constants.convertedImageFormat, constants.convertedImageQuality),
                imageWidth: canvas.width,
                imageHeight: canvas.height,
                numPages: pdf.numPages,
                currentPage: pageNumber,
                pdfFile: pdf
            });
        }
    }

    public featureStyler = (feature) => {
        const regionId = feature.get("id");
        return new Style({
            stroke: new Stroke({
                color: "#fffc7f",
                width: 1,
            }),
            fill: new Fill({
                color: "rgba(255, 252, 127, 0.2)",
            }),
        });
    }

    public noOp = () => {
        // no operation
    }

    public renderImageMap = () => {
        return (
            <ImageMap
                initEditorMap={true}
                ref={(ref) => this.imageMap = ref}
                imageUri={this.state.imageUri}
                imageWidth={this.state.imageWidth}
                imageHeight={this.state.imageHeight}
                featureStyler={this.featureStyler}
                onMapReady={this.noOp}
            />
        );
    }


    public render() {
        const { project } = this.props;
        const { assets, analyseDataLoad, selectedAsset,validationCheck,endpoint,userTransformations,uploadFilesCount,filesCount } = this.state;
       
      //console.log("filescount in test ==>"+filesCount);
        if (!project) {
          //  return (<div className="text-center mt-5">Loading...</div>);
        }
 
        return (
            <>
                <HeaderComponent
                    history={this.props.history}
                    match={this.props.match}
                    location={this.props.location} />
                <OperationsHeader propsMatch={this.props.match} />
{/*
                <BeforeUnloadComponent
                        alertMessage='Are you sure you want to leave? Changes will not be saved.'
                    >*/
}

                <div className="container-fluid animated fadeIn editor-page-test" id="testPageEditor">
                    <SplitPane split="vertical"
                        defaultSize={this.state.thumbnailSize.width}
                        minSize={175}
                        maxSize={175}
                        paneStyle={{ display: "flex" }}
                        onChange={this.onSideBarResize}
                        onDragFinished={this.onSideBarResizeComplete}>
                        <div className="editor-page-test-sidebar bg-lighter-1">
                            <div className="tag-input-header p-1 text-center">
                              
                                <Link to={`/operations/projects`} type="button" className="btn-custom"  >
                                    <i className="fa fa fa-upload" aria-hidden="true"></i> Upload</Link>
                                

                            </div>
                            {assets && size(assets) > 0 ?
                                <EditorSideBar
                                    assets={assets}
                                    selectedAsset={selectedAsset ? selectedAsset.asset : null}
                                    onBeforeAssetSelected={this.onBeforeAssetSelected}
                                    onDeleteSelected={this.deleteAsset}
                                    onAssetSelected={this.selectAsset}
                                    thumbnailSize={this.state.thumbnailSize}
                                    setImageUriInAsset={this.props.actions.updateAssetWithImageUri}
                                />
                                :
                                <>
                                {/* {this.showLoader()} */}
                                {/* {assets && size(assets) === 0 && !this.state.loadingFiles ? 
                                <div className="text-center">Please (wait/upload) Files to Test</div>*/}
                                {  
                                 <Spinner
                                size={SpinnerSize.small}
                                label="Loading Files"
                                ariaLive="off"
                                labelPosition="bottom"
                                />
                                    } 
                                </>
                            }
                        </div>
                        <div className="editor-page-test-content">
                            <div className="editor-page-test-content-main" >
                                {/* <div className="editor-page-test-content-main-body"> */}
                                {assets && size(assets) > 0 ? 
                                     <div className="editor-page-test-content-main-body">
                                    {this.state.imageUri
                                        ?
                                        <>
                                         <ImageMap
                                            initEditorMap={true}
                                            ref={(ref) => this.imageMap = ref}
                                            imageUri={this.state.imageUri || ""}
                                            imageWidth={this.state.imageWidth}
                                            imageHeight={this.state.imageHeight}
                                            featureStyler={this.featureStyler}
                                            onMapReady={this.noOp}
                                        />
                                        { this.shouldShowPreviousPageButton() &&
                                            <IconButton
                                                className="toolbar-btn prev"
                                                title="Previous"
                                                iconProps={{iconName: "ChevronLeft"}}
                                                onClick={this.prevPage}
                                            />
                                        }
                                        { this.shouldShowNextPageButton() &&
                                            <IconButton
                                                className="toolbar-btn next"
                                                title="Next"
                                                onClick={this.nextPage}
                                                iconProps={{iconName: "ChevronRight"}}
                                            />
                                        }
                                        { this.shouldShowMultiPageIndicator() &&
                                            <p className="page-number">
                                                Page {this.state.currentPage} of {this.state.numPages}
                                            </p>
                                        }
                                        </>
                                        :
                                        <div className="canvas-ocr-loading">
                                            <div className="canvas-ocr-loading-spinner">
                                                <Spinner size={SpinnerSize.large} label="Loading File..." ariaLive="assertive" labelPosition="right" />
                                            </div>
                                        </div>
                                    }
                                 </div>:
                                 <div className="text-center mt-5">Please Select any file</div>
                                }
                                {/* </div> */}
                            </div>
                            <div className="editor-page-test-right-sidebar hidden">

                            </div>
                            <div className="editor-page-test-right-sidebar">                          

                                <div className="tag-input">

                                    <div>
                                    <button
                                                disabled={assets && size(assets) === 0 || !assets}
                                                onClick={() => this.showForm()} className="btn-custom">
                                                <i className="fa fa-plus" aria-hidden="true"></i> Add End Point
                                            </button>
                                    </div>
                                    <div>
                                    <>
                                        {size(userTransformations) > 0 ?                                            
  
                                                                <div className="mt-2">
                                                                    <div className="mt-2 url_css" title={userTransformations[0].endpoint}>

                                                                        <i className="fa fa-link" aria-hidden="true"></i> {userTransformations[0].endpoint}
                                                                    </div>
                                                                </div>
                                                                 
                                            : <div className="text-center mt-5">No End Point Available</div>}
                                    </>
                                    </div>
                                <div>
                                                <label>Select Format:</label>
                                                <Select options={this.state.loadResultFormates}
                                                onChange={this.getFormatType}
                                                value={this.state.selectedFormat}
                                                placeholder="Select Format"
                                                // className="react-select-container zindex-20"
                                                isClearable={true}
                                                theme={(theme) => ({
                                                    ...theme,
                                                    colors: {
                                                        ...theme.colors,
                                                        primary25: "#161a1f",
                                                        primary: "#6b727d",
                                                        neutral0: "#222830",
                                                        neutral20: "#44474c",
                                                        neutral30: "#272c33",
                                                        neutral50: "#fff",
                                                        neutral80: "#9da7b5",
                                                    },
                                                })}

                                            />
                                            </div>


                                    <div className="tag-input-header p-1">

                                        <div className="tag-input-toolbar test-conttols">                                          
                                            <button
                                                disabled={assets && size(assets) === 0 || !assets}
                                                onClick={() => this.analyseData("raw")} className="btn-custom">
                                                <i className="fa fa-code" aria-hidden="true"></i> Result
                                            </button>
                                            &nbsp;
                                            {/* <button
                                                disabled={size(assets) === 0}
                                                className="btn-custom" onClick={() => this.analyseData("transform")}>
                                                <i className="fa fa-code" aria-hidden="true"></i> Transform
                                            </button>
                                            &nbsp; */}
                                            <button type="button" disabled={assets && size(assets) === 0 || !assets} onClick={() => this.downloadJson()} title="Export1" className="btn-custom" >
                                                <i className="fa fa-file-export" aria-hidden="true"></i>Export </button>
                                        </div>
                                    </div>
                                    <div className="tag-input-body-container">
                                        <div className="tag-input-body">

                                            <div className="tag-input-items">

                                            </div></div>

                                        <div className="sec-rt">
                                            {this.state.analyzeResult &&
                                                <JsonResponse
                                                    history={this.props.history}
                                                    match={this.props.match}
                                                    location={this.props.location}
                                                    project={this.props.project}
                                                    outPutFormat={this.state.outPutFormat}
                                                    jsonData={this.state.analyzeResult}
                                                />
                                            }
                                            {this.state.errorMessage
                                                && <p className="text-center mt-5">{this.state.errorMessage["error"]["message"]}</p>}
                                            {/* {this.state.analyseDataLoad
                                                && <Spinner
                                                    label="Loading JSON"
                                                    ariaLive="off"
                                                    className="loading" size={SpinnerSize.large} />} */}

                                        </div>
                                    </div>
                                </div>
                            </div>
                            <Confirm title="Delete File"
                                ref={this.deleteFileConfirm}
                                message="Are you sure you want to delete this File ?"
                                confirmButtonTheme={getPrimaryRedTheme()}
                                onCancel={this.onDeleteFileCancel}
                                onConfirm={this.onDeleteFile} />
                        </div>
                    </SplitPane>
                    <SkipButton skipTo="testPageEditor">{strings.common.skipToMainContent}</SkipButton>
                </div>
                {this.state.analyseDataLoad &&
                    <div className="canvas-ocr-loading">
                        <div className="canvas-ocr-loading-spinner">
                            <Label className="p-0" ></Label>
                            <Spinner size={SpinnerSize.large} label="Your Document is transforming please wait ..!" ariaLive="assertive" labelPosition="right"/>
                        </div>
                    </div>
                }
                {/*
               </BeforeUnloadComponent> */
                }
                
                {this.state.addEndPoint &&
                    <div className="model_add">
                        <LoadingOverlay
                            active={this.state.createValidation}
                            spinner
                            text="Creating Endpoint">
                            <div className="row ">

                                <div className="col-md-6 offset-md-3">
                                    <div className="card shadow">

                                        <div className="card-header">
                                            <div className="text-center">
                                                <h5>Add Prediction EndPoint</h5>

                                            </div>
                                        </div>

                                        <div className="card-body">

                                            <div className="row">

                                              

                                                <div className="col-md-12" >
                                                    <label>Endpoint:</label>
                                                    <input type="text" className="form-control" id="endpoint" name="endpoint"
                                                        onChange={this.getInputValues} placeholder="" />
                                                    {!validationCheck && <div className="text-danger"> Give valid End Point</div>}
                                                </div>
 
                 

                                               

                                            </div>

                                        </div>

                                    </div>

                                    <div className="card-footer text-center">
                                        <button type="submit"
                                            onClick={this.createValidation}
                                            disabled={ !endpoint  }
                                            className="btn btn-sm mr-2">Add</button>
                                        <button type="button"
                                            className="btn btn-sm" onClick={() => this.showForm()}>Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </LoadingOverlay>
                    </div>
                }
                
            </>
        );
    }


    /** delete file */
    private deleteAsset = async (asset: IAsset) => {
        await this.updateAssetState(asset.id, false);
        this.deleteFileConfirm.current.open(asset);
    }

    private onDeleteFileCancel = () => {
        if (this.renameCanceled) {
            this.renameCanceled();
            this.renameCanceled = null;
        }
    }

    private onDeleteFile = async (asset: IAsset) => {
        this.updateAssetState(asset.id, true);
        const { project } = this.props;
        const parts = asset.name.split("/");
        const fileName = parts.pop();
        const headers = accessToken();
        const URL = deleteBlobEndPoint(project.name, fileName);
        try {
            const deleted = await axios(URL, { method: "GET", headers });
            if (deleted && deleted.data === "Blobs deleted successfully!") {
            this.props.actions.deleteAsset(asset);
            this.updateAssetState(asset.id, false);
            this.loadProjectAssets();
            } else {
                this.updateAssetState(asset.id, false);
                this.loadProjectAssets();
            }
        } catch (err) {
            let response;
            if (err.response.status == 401) {
                const body = {
                    refreshToken: refreshTokenCall()
                }
                response = await ServiceHelper.postWithAutoRetry(
                    refreshTokenEndPoint(), body, { headers });
                if (response.data.status == 200) {
                    const signInUserSession = localStorage.getItem("signInUserSession");
                    const user = signInUserSession && JSON.parse(signInUserSession);
                    const updateAccessToken = Object.assign({}, user)
                    updateAccessToken.access_token = response.data.access_token
                    updateAccessToken.refresh_token = response.data.refresh_token
                    try {
                        const deleted = await axios(URL, { method: "GET", headers });
                        if (deleted && deleted.data === "Blobs deleted successfully!") {
                            this.props.actions.deleteAsset(asset);
                            this.updateAssetState(asset.id, false);
                            this.loadProjectAssets();
                            } else {
                                this.updateAssetState(asset.id, false);
                                this.loadProjectAssets();
                            }
                    } catch (err) {
                        ServiceHelper.handleServiceError(err);
                    }

                }
            } else {
                ServiceHelper.handleServiceError(err);
            }
        }
    }

    private updateAssetState = (id: string, isDeleting: boolean) => {
        this.setState((state) => ({
            assets: state.assets.map((asset) => {
                if (asset.id === id) {
                    const updatedAsset = { ...asset, isDeleting };
                    return updatedAsset;
                } else {
                    return asset;
                }
            }),
        }), () => {
            if (this.state.selectedAsset && id === this.state.selectedAsset.asset.id) {
                const asset = this.state.assets.find((asset) => asset.id === id);
                if (asset) {
                    this.setState({
                        selectedAsset: { ...this.state.selectedAsset, asset: { ...asset } },
                    });
                }
            }
        });
    }

    /**
     * Called when the asset side bar is resized
     * @param newWidth The new sidebar width
     */
    private onSideBarResize = (newWidth: number) => {
        this.setState({
            thumbnailSize: {
                width: newWidth,
                height: newWidth / (4 / 3),
            },
        });
    }

    /**
     * Called when the asset sidebar has been completed
     */
    private onSideBarResizeComplete = () => {
        const appSettings = {
            ...this.props.appSettings,
            thumbnailSize: this.state.thumbnailSize,
        };

        this.props.applicationActions.saveAppSettings(appSettings);
    }

    /**
     * Returns a value indicating whether the current asset is taggable
     */
    private isTaggableAssetType = (asset: IAsset): boolean => {
        return asset.type !== AssetType.Unknown;
    }

    /**
     * Raised when the selected asset has been changed.
     * This can either be a parent or child asset
     */
    private onAssetMetadataChanged = async (assetMetadata: IAssetMetadata): Promise<void> => {
        // Comment out below code as we allow regions without tags, it would make labeler's work easier.

        const initialState = assetMetadata.asset.state;

        const asset = { ...assetMetadata.asset };

        if (this.isTaggableAssetType(assetMetadata.asset)) {
            assetMetadata.asset.state = _.get(assetMetadata, "labelData.labels.length", 0) > 0 ?
                AssetState.Tagged :
                AssetState.Visited;
        } else if (assetMetadata.asset.state === AssetState.NotVisited) {
            assetMetadata.asset.state = AssetState.Visited;
        }

        // Only update asset metadata if state changes or is different
        if (initialState !== assetMetadata.asset.state || this.state.selectedAsset !== assetMetadata) {
            await this.props.actions.saveAssetMetadata(this.props.project, assetMetadata);
            if (this.props.project.lastVisitedAssetId === assetMetadata.asset.id) {
                this.setState({ selectedAsset: assetMetadata });
            }
        }

        // Find and update the root asset in the internal state
        // This forces the root assets that are displayed in the sidebar to
        // accurately show their correct state (not-visited, visited or tagged)
        const assets = [...this.state.assets];
        const assetIndex = assets.findIndex((a) => a.id === asset.id);
        if (assetIndex > -1) {
            assets[assetIndex] = {
                ...asset,
            };
        }

        this.setState({ assets, isValid: true });

        // Workaround for if component is unmounted
        if (!this.isUnmount) {
            this.props.appTitleActions.setTitle(`${this.props.project.name} - [ ${asset.name} ]`);
        }
    }

    private onBeforeAssetSelected = (): boolean => {
        if (!this.state.isValid) {
            this.setState({ showInvalidRegionWarning: true });
        }

        return this.state.isValid;
    }

    private selectAsset = async (asset: IAsset): Promise<void> => {
        // Nothing to do if we are already on the same asset.
        this.cancelToken = undefined;
        if (this.state.selectedAsset && this.state.selectedAsset.asset.id === asset.id) {
            return;
        }

        if (!this.state.isValid) {
            this.setState({ showInvalidRegionWarning: true });
            return;
        }
        const {assets } = this.state;
        localStorage.setItem("OPlastVisttedtestAssetId", asset.id);
        const assetMetadata = {
            asset: { ...asset },
            regions: [],
            version: appInfo.version,
            labelData: null,
        }
        this.setState({
            imageUri: null,
            selectedAsset: assetMetadata,
        }, async () => {
            await this.loadImage();
         //   await this.analyseData("transform");
            // await this.onAssetMetadataChanged(assetMetadata);
        });
    }


    private loadProjectAssets = (): Promise<void> => {
        if (this.loadingProjectAssets) {
            return;
        }

        this.loadingProjectAssets = true;
        const projectCopy = Object.assign({}, this.props.project);
        projectCopy.folderPath = `${this.props.match.params["projectName"]}-${this.state.userId}/testing`;
        const rootAssets: IAsset[] = this.props.loadAllOPTestFiles;

        
        if (this.state.assets && this.state.assets.length === rootAssets.length
            && this.state.assets.map((asset) => asset.id).join(",") === rootAssets.map((asset) => asset.id).join(",")) {
            this.loadingProjectAssets = false;
            return;
        }
        const lastVisited = localStorage.getItem("OPlastVisttedtestAssetId");
        const lastVisitedAsset = rootAssets.find((asset) => asset.id === lastVisited);
        this.setState({
            assets: rootAssets,
        }, async () => {
            if (rootAssets.length > 0) {
                this.selectAsset(lastVisitedAsset ? lastVisitedAsset : rootAssets[0]);
            }
            this.loadingProjectAssets = false;
        });
    }
    private loadProjectAssets_OLD = (): Promise<void> => {
        if (this.loadingProjectAssets) {
            return;
        }

        this.loadingProjectAssets = true;
        const projectCopy = Object.assign({}, this.props.project);
        projectCopy.folderPath = `${this.props.match.params["projectName"]}-${this.state.userId}/testing`;
       
       // const rootAssets: IAsset[] = this.props.loadAllTestFiles;
      //  debugger;
        if (this.state.assets)
        { 
       const rootAssets: IAsset[] =this.state.assets ;
      /*  if (this.state.assets && this.state.assets.length === rootAssets.length
            && this.state.assets.map((asset) => asset.id).join(",") === rootAssets.map((asset) => asset.id).join(",")) {
            this.loadingProjectAssets = false;
            return;
        }*/
        const lastVisited = localStorage.getItem("lastVisttedtestAssetId");
        const lastVisitedAsset = rootAssets.find((asset) => asset.id === lastVisited);
        this.setState({
            assets: rootAssets,
        }, async () => {
            if (rootAssets.length > 0) {
                this.selectAsset(lastVisitedAsset ? lastVisitedAsset : rootAssets[0]);
            }
            this.loadingProjectAssets = false;
        });
    }
    }

    private updateAssets = () => {
        const rootAssets: IAsset[] = this.props.loadAllOPTestFiles;
        this.setState({
            assets: rootAssets,
        });
    }

    private downloadJson = async () => {
        const parts = this.state.selectedAsset.asset.name.split("/");
        const fileName = parts.pop() || parts.pop();
        const nameFile = fileName.replace(/(.*)\.[^.]+$/, "$1");
        const myData = this.state.analyzeResult
        const json = JSON.stringify(myData);
        const blob = new Blob([json], { type: 'application/json' });
        const href = await URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = href;
        link.download = nameFile + ".json";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    // https://document-prediciton.azurewebsites.net/api/HttpTrigger1?project_name=project_2

    /** Analyse data from azure */
    private analyseData = async (outPutFormat?: string) => {

       // debugger;
        if (this.cancelToken !== undefined) {
            this.cancelToken.cancel("Operation canceled due to going new component.");
        } else {
          // Save the cancel token for the current request
        if (outPutFormat) {

            if(size(this.state.userTransformations)>0)
            {
        this.setState({ analyzeResult: null, analyseDataLoad: true });
        const parts = this.state.selectedAsset.asset.name.split("/");
        const fileName = parts.pop() || parts.pop();
        const projectName = this.props.match.params["projectName"];

        const signInUserSession = localStorage.getItem("signInUserSession");
        const user = signInUserSession && JSON.parse(signInUserSession);
        const accessToken = user && user.access_token;
        const headers = {
            "Access-Control-Allow-Origin":"*",
            "Content-Type": "application/json,image/jpeg,application/pdf", "Authorization": `Bearer ${accessToken}`, "cache-control": "no-cache" };
        // return accessToken;

        //const headers = accessToken();
        const accessTokenBody = accessTokenData();
        this.cancelToken = axios.CancelToken.source();
        const newURL= this.state.userTransformations[0].endpoint;
        const epnewURL = newURL+"?file_name="+fileName;


        console.log("new URL"+epnewURL);
        //const URL = documentPredictionEndPoint(projectName, fileName, outPutFormat);
        try {
            const analysedData = await axios(epnewURL, { method: "POST", headers,
             data: {token: accessTokenBody},
              cancelToken: this.cancelToken.token });
              debugger;
            if (analysedData) {
                this.setState({ analyseDataLoad: false });
                if (outPutFormat === "transform" && analysedData.data) {
                    this.setState({ analyzeResult: analysedData.data, outPutFormat: "Transform JSON Response" });
                } else if (outPutFormat === "raw" && analysedData.data) {
                    this.setState({ analyzeResult: analysedData.data, outPutFormat: "Raw JSON Response" });
                                 
                    //store this data to use in Transformations
                    const projectId = this.props.match.params["projectId"];
                    const recentProject = this.props.recentProjects.find((project) => project.id === projectId);
            const projectCopy = Object.assign({}, recentProject);
            projectCopy.analyzeResult =  analysedData.data;
           // projectCopy.folderPath = `${projectName}-${userId}/testing`;
          ///  await this.props.actions.saveProject(projectCopy, false, false);
           // await this.props.actions.loadProject(projectCopy);

                    //
              
                } else if (analysedData.data.error) {
                    const data2 = analysedData.data.error.substr(analysedData.data.error.indexOf(":") + 1); // "tocirah sneab"
                    const errorJson = JSON.parse(data2);
                    this.setState({ errorMessage: errorJson });
                }
            } else {
                this.setState({ analyseDataLoad: false });
            }

        } catch (err) {
            let response;

            ServiceHelper.handleServiceError(err);
        }

    }
    else
    {
         toast.warn(`Please add the end point!`);
    }

}


    }
    }

    private onFocused = () => {
        this.loadProjectAssets();
    }

    private nextPage = async () => {
        if ((this.state.pdfFile !== null || this.state.tiffImages.length !== 0)
            && this.state.currentPage < this.state.numPages) {
            await this.goToPage(this.state.currentPage + 1);
        }
    }

    private prevPage = async () => {
        if ((this.state.pdfFile !== null || this.state.tiffImages.length !== 0) && this.state.currentPage > 1) {
            await this.goToPage(this.state.currentPage - 1);
        }
    }
    
    private shouldShowPreviousPageButton = () => {
        return (this.state.pdfFile !== null || this.state.tiffImages.length !== 0) && this.state.currentPage !== 1;
    }

    private shouldShowNextPageButton = () => {
        return (this.state.pdfFile !== null || this.state.tiffImages.length !== 0)
            && this.state.currentPage !== this.state.numPages;
    }

    private shouldShowMultiPageIndicator = () => {
        return (this.state.pdfFile !== null || this.state.tiffImages.length !== 0) && this.state.numPages > 1;
    }

    private goToPage = async (targetPage: number) => {
        if (targetPage < 1 || targetPage > this.state.numPages) {
            // invalid page number, just return
        }
        // switch image
        await this.switchToTargetPage(targetPage);

    }

    private switchToTargetPage = async (targetPage: number) => {
        if (this.state.pdfFile !== null) {
            await this.loadPdfPage(this.state.selectedAsset.asset.id, this.state.pdfFile, targetPage);
        } else if (this.state.tiffImages.length !== 0) {
            this.loadTiffPage(this.state.tiffImages, targetPage);
        }
    }
    /** Result format type */
    private getFormatType = (selectedFormat: any) => {
        this.setState({ selectedFormat });
    }

    /**
     * show Form
     */
    private showForm = () => {
        const { addEndPoint } = this.state;
        this.setState({ addEndPoint: !addEndPoint });
    }

    /**
     * Create Validation
     */
    private createValidation = async () => {
       
        this.setState({ createValidation: true });
        const {  endpoint, userTransformations } = this.state;
        
        const endPointData = {
            project_name: "",
            endpoint_type: "transformation",
            category:"" ,
            active_status: "",
        };
        const body = {};
        body["endpoint_name"] = "endpoint_name";
        body["endpoint"] = endpoint;

//new change start
let noofrows=1;
 

const newendPointData = {
      
    _id: "1",
    active_status: "",
    category : "",
    endpoint: endpoint,
    endpoint_type: "transformation",
    endpoint_name: "endpoint_name",
    project_name: " ",
    updated_date: new Date().toDateString(),
};

userTransformations.push(newendPointData);
this.setState({ userTransformations: userTransformations });
//new change end

     
        this.setState({ endpoint: null,   createValidation: false, addEndPoint: false });
        this.getValidationsTransform(endPointData.project_name);
    }

    /**
     * get event values based on name
     */
    private getInputValues = (event) => {
        if (event.target.name === "endpoint") {
        // const regexQuery = "^(https?://)?(www\\.)?([-a-z0-9]{1,63}\\.)*?[a-z0-9][-a-z0-9]{0,61}[a-z0-9]\\.[a-z]{2,6}(/[-\\w@\\+\\.~#\\?&/=%]*)?$";
            
            const regexQuery =  "^((http|https)://)?"
              + "[a-zA-Z0-9@:%._\\+~#?&//=]"
              + "{2,256}\\.[a-z]"
              + "{2,6}\\b([-a-zA-Z0-9@:%"
              + "._\\+~#?&//=]*)$"; 
            const url = new RegExp(regexQuery, "i");
           // if (url.test(event.target.value)) {
            if (event.target.value) {
                this.setState({ ...this.state, validationCheck: true, [event.target.name]: event.target.value });
            } else {
                this.setState({ validationCheck: false });
            }
        } else {
            this.setState({ ...this.state, [event.target.name]: event.target.value });
        }
    }

     /**
     * get validations and transform
     */
    private getValidationsTransform = async (projectName) => {
        //  debugger;
          this.setState({ loadEndPoints: true});
          //if (projectName) {
            //  const endPointType = {
                //  project_name: projectName,
                  //endpoint_type: "transformation",
            //  };
  
              // new changes start
           
       //  const loadEndPointData = await this.props.userDefinedActions.loadEndPoints(endPointType);
          const loadEndPointData = this.state.userTransformations;
  
        //   console.log("end points"+ JSON.stringify(loadEndPointData));
        //   console.log("end points1"+ loadEndPointData);
           // new changes end
             // const loadEndPointData = await this.props.userDefinedActions.loadEndPoints(endPointType);
              if (loadEndPointData) {
                  this.setState({ userTransformations: loadEndPointData, loadEndPoints: false });
              } else {
                  this.setState({ loadEndPoints: false });
              }
              // this.props.userDefinedActions.loadEndPoints(endPointType).then((data) => {
              //     this.setState({ userTransformations: data, loadEndPoints: false });
              // }).catch(() => {
              //     this.setState({ loadEndPoints: false });
              // });
         // }
      }
  
}
